import { QueryClient } from '@tanstack/react-query';

/**
 * react-query doesn't really belong in this workspace, but was added to get at infinite
 * loading behavior for the team member dropdown. This package depends on v4 of react-query
 * becuase form-app is not yet on v18 of react (required for v5).
 */
export const unsafeRootQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 1 minute:  How long mark this item as being fresh it is considered stale.
      staleTime: 60000,
      // 10 minutes: Stays in memory for this length of time.
      cacheTime: 600000,
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchOnWindowFocus: true,
      retry: 3, // Retry all rejections 3 times
      retryOnMount: true, // Failed results will be retried if they are requested again
      useErrorBoundary: true, // Queries should fail to the EB when it rejects.
    },
    mutations: {
      retry: false, // Never retry failed mutations

      // Mutations should not arrive at EB since it would
      // clear local state that would likely lose user data
      useErrorBoundary: false,
    },
  },
});
